import { CarSimpleIcon } from '@phosphor-icons/react';
import { programByCode, type LoyaltyProgram } from '@voll-intelligence/domain';
import { useGenUiConfig } from '../../../../shared/ui/config.js';
import { CatalogProgramMark, CheckoutLoyaltyLine } from '../checkout_loyalty.js';
import type { RentalCheckoutItem } from './checkout_contract.js';

/** Os programas das locadoras do card, um por programa, pelo código da locadora
 *  (`rental.id`, ex.: "MO" → Fidelidade Movida). Card antigo sem o código ou
 *  locadora fora do catálogo não tem linha. */
function rentalLoyaltyPrograms(items: readonly RentalCheckoutItem[]): LoyaltyProgram[] {
  const programs = new Map<string, LoyaltyProgram>();
  for (const { detail } of items) {
    const code = detail.companyCode?.trim().toUpperCase();
    const program = code ? programByCode('rental', code) : undefined;
    if (program && !programs.has(program.id)) programs.set(program.id, program);
  }
  return [...programs.values()];
}

/** A linha de fidelidade do card de carro (#6159), com as regras da do aéreo:
 *  só com o port que lê os programas de locadora e com quem está logado
 *  viajando sozinho. */
export function RentalCheckoutLoyalty({
  items,
  self,
  record,
}: {
  readonly items: readonly RentalCheckoutItem[];
  /** O único viajante é quem está logado. */
  readonly self: boolean;
  readonly record: boolean;
}) {
  const port = useGenUiConfig().loyalty;
  if (!port?.useRentalPlans || !self) return null;
  const { logoOf } = port;
  return (
    <CheckoutLoyaltyLine
      programs={rentalLoyaltyPrograms(items)}
      usePlans={port.useRentalPlans}
      record={record}
      appliedKey="productCheckout.loyalty.appliedProgram"
      onAdd={port.openAdd}
      renderMark={(program) => (
        <CatalogProgramMark logo={logoOf?.(program.id) ?? null} icon={<CarSimpleIcon />} />
      )}
    />
  );
}
